<div class="timezone" [formGroup]="scheduleReport.scheduleForm">
    <h3 color="primary">Schedule Time Zone</h3>
    <div class="row">
        <div class="group">
            <mat-form-field *ngIf="'timezone' as field">
                <mat-select formControlName="timezone">
                    <mat-option *ngFor="let tz of (timezone$ | async)" [value]="tz">
                        {{ tz | uppercase }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>